import { memo } from 'react';
import { ToastContainer as LibToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseSvg from '@assets/svg/CloseSvg';
import styles from './ToastContainer.module.scss';

const CustomerCloseButton = ({ closeToast }: { closeToast: () => void }) => (
    <CloseSvg onClick={closeToast} className={styles.closeToastIcon} />
);

const ToastContainer = () => (
    <LibToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeButton={CustomerCloseButton}
        limit={1}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className={styles.topRight}
        toastClassName={styles.toastContainer}
        bodyClassName={styles.toastBody}
    />
);

export default memo(ToastContainer);
